/**
 * UcActions — блок «Действия» UC-панели (screen-22, эталон html:217-221 +
 * updActs js:60): кнопки «+ Бонус/Штраф» и «+ Обмен» открывают формы;
 * УД12 «Отмена одна» — обе кнопки хедера скрыты, пока открыта ЛЮБАЯ из
 * двух форм (закрытие только кнопкой «Отмена» самой формы / успехом).
 */
import { useState, type MouseEvent } from "react";
import type { UcAdmin } from "../../hooks/useUcAdmin";
import { UcFormB } from "./UcFormB";
import { UcFormX } from "./UcFormX";
import cfg from "./config.module.css";
import pcss from "./prices.module.css";
import qcss from "./quests.module.css";
import ucss from "./uc.module.css";

/** Молния шапки (эталон html:218). */
const BoltIco = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M13 2L4 14h6l-1 8 9-12h-6z" />
  </svg>
);

export function UcActions({ uc, onTip }: {
  uc: UcAdmin;
  onTip: (e: MouseEvent<HTMLButtonElement>) => void;
}) {
  const [formB, setFormB] = useState(false);
  const [formX, setFormX] = useState(false);
  const open = formB || formX; // УД12

  return (
    <div className={ucss.blk}>
      <div className={`${qcss.s17head} ${ucss.hd}`}>
        <span className={ucss.hgr}><BoltIco /></span>
        <h2 className={`${cfg.secT} ${qcss.cformT}`}>Действия</h2>
        <button type="button" className={pcss.qmark} data-qmark="" aria-label="Справка" onClick={onTip}>
          <span>?</span>
        </button>
        {!open ? (
          <>
            <button
              type="button"
              className={`${qcss.abtn} ${qcss.cf} ${qcss.solo} ${ucss.soloS}`}
              onClick={() => setFormB(true)}
            >
              + Бонус/Штраф
            </button>
            <button
              type="button"
              className={`${qcss.abtn} ${qcss.cf} ${qcss.solo} ${ucss.soloS}`}
              onClick={() => setFormX(true)}
            >
              + Обмен
            </button>
          </>
        ) : null}
      </div>
      {formB ? (
        <UcFormB balances={uc.balances} busy={uc.busy} submit={uc.bonus} onClose={() => setFormB(false)} />
      ) : null}
      {formX ? (
        <UcFormX balances={uc.balances} busy={uc.busy} submit={uc.exchange} onClose={() => setFormX(false)} />
      ) : null}
    </div>
  );
}
